import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import BaseViewModel from "./../factories/base-view-model";
import TreeNodeViewModel from "./../factories/tree-node";
import "./../bindings/bao-tree";
import "./../bindings/bao-searcher";
function CreationWizardDialogViewModel(tabPage) {
    var self = this;
    self.ParentConfigurationItemTypeId = ko.observable();
    self.ChildConfigurationItemTypeId = ko.observable();
    self.ChildConfigurationItemTypeName = ko.observable();
    self.ConfigurationItemName = ko.observable();
    self.WithChildObjects = ko.observable(true);
    self.EditAllowed = ko.observable(true);
    self.EnableOk = ko.observable(false);
    self.ChildConfigurationItemTypeName.subscribe(function () {
        self.ConfigurationItemName(self.ChildConfigurationItemTypeName());
    });
    self.ChildConfigurationItemTypeId.subscribe(function () {
        self.EnableOk(self.CheckInput());
    });
    self.ConfigurationItemName.subscribe(function () {
        self.EnableOk(self.CheckInput());
    });
    self.EditAllowed.subscribe(function () {
        self.EnableOk(self.CheckInput());
    });
    self.CheckInput = function () {
        if (self.EditAllowed()) {
            if (self.ChildConfigurationItemTypeId() != null) {
                if (self.ConfigurationItemName() != null && $.trim(self.ConfigurationItemName()) != "") {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
        else {
            if (self.ConfigurationItemName() != null && $.trim(self.ConfigurationItemName()) != "") {
                return true;
            }
            else {
                return false;
            }
        }
    };
}
function CreationWizardViewModel(tabPage) {
    var self = this;
    BaseViewModel.call(this, tabPage);
    self.SelectedConfigurationItemId = ko.observable();
    self.SelectedConfigurationItemName = ko.observable();
    self.RootConfigurationItem = ko.observable();
    self.withReminder = ko.observable(true);
    self.Nodes = ko.observableArray([]);
    self.SelectedNode = ko.observable();
    self.SelectedConfigurationItemId.subscribe(function () {
        tabPage.ObjectId("creationWizard" + self.SelectedConfigurationItemId());
        self.Refresh();
    });
    self.SelectedNode.subscribe(function () {
        self.ToggleButtons();
    });
    self.ToggleButtons = function () {
        var enabled = self.SelectedNode() != null;
        BaoMenu.permissionEnable({
            ActionKey: "CreationWizardObjectAdd",
            Enabled: enabled,
            Context: tabPage.Context()
        });
        BaoMenu.permissionEnable({
            ActionKey: "CreationWizardEdit",
            Enabled: enabled && self.SelectedNode().IsNew() == true,
            Context: tabPage.Context()
        });
        BaoMenu.permissionEnable({
            ActionKey: "CreationWizardObjectDelete",
            Enabled: enabled && self.SelectedNode().IsNew() == true,
            Context: tabPage.Context()
        });
        var rootNode = ko.map.toJS(self.Nodes()[0]);
        if (rootNode) {
            BaoMenu.permissionEnable({
                ActionKey: "CreationWizardSave",
                Enabled: enabled && self.TreeHasNewNode(rootNode, false),
                Context: tabPage.Context()
            });
        }
        else {
            BaoMenu.permissionEnable({
                ActionKey: "CreationWizardSave",
                Enabled: enabled,
                Context: tabPage.Context()
            });
        }
    };
    self.RefreshInProgress = ko.observable(false);
    self.Refresh = function () {
        var def = $.Deferred();
        if (self.SelectedConfigurationItemId() != null) {
            tabPage.IsLoading(true);
            self.SelectedNode(null);
            self.RefreshInProgress(true);
            Bao.post("CreationWizard/Load", JSON.stringify({
                parentConfigurationItemId: self.SelectedConfigurationItemId()
            }), function (value) {
                var newItems = [];
                if (value != null && value.length > 0) {
                    $.each(value, function (index, row) {
                        var node = new TreeNodeViewModel(row);
                        newItems[index] = node;
                    });
                }
                self.Nodes(newItems);
                tabPage.IsLoading(false);
                self.RefreshInProgress(false);
                def.resolve();
            });
        }
        else {
            self.Nodes([]);
            def.resolve();
        }
        return def.promise();
    };
    self.TreeHasNewNode = function (currentNode, hasChanges) {
        var current = false || hasChanges;
        if (currentNode != null) {
            if (currentNode.IsNew) {
                current = current || true;
            }
            else {
                current = current || false;
            }
            $.each(currentNode.Nodes, function (index, item) {
                current = current || self.TreeHasNewNode(item, current);
            });
        }
        return current;
    };
    self.RemoveParentRek = function (currentNode) {
        if (currentNode != null) {
            currentNode.Parent = null;
            $.each(currentNode.Nodes, function (index, item) {
                self.RemoveParentRek(item);
            });
        }
    };
    self.SaveTree = function () {
        tabPage.IsLoading(true);
        var rootNode = ko.map.toJS(self.Nodes()[0]);
        self.RemoveParentRek(rootNode);
        return Bao.post("CreationWizard/SaveTree", JSON.stringify({
            rootNode: rootNode,
            withReminder: self.withReminder()
        }), function (value) {
            var newItems = [];
            if (value != null && value.length > 0) {
                $.each(value, function (index, row) {
                    var node = new TreeNodeViewModel(row);
                    newItems[index] = node;
                });
            }
            self.Nodes(newItems);
            tabPage.IsLoading(false);
        });
    };
    self.CreationWizardAddObject = function () {
        var currentNode = ko.map.toJS(self.SelectedNode());
        self.RemoveParentRek(currentNode);
        return Bao.post("CreationWizard/NewModel", JSON.stringify({
            parentItem: currentNode
        }), function (newModel) {
            self.ShowDialog(newModel, function (result) {
                return self.AddNew(result);
            });
        });
    };
    self.AddNew = function (newItemModel) {
        tabPage.IsLoading(true);
        return Bao.post("CreationWizard/CreateNewNode", JSON.stringify({
            newModel: ko.map.toJS(newItemModel)
        }), function (node) {
            var newNode;
            newNode = new TreeNodeViewModel(node, self.SelectedNode());
            self.SelectedNode().Nodes.push(newNode);
            self.SortNodes(self.SelectedNode().Nodes);
            self.SelectedNode(newNode);
            tabPage.IsLoading(false);
        });
    };
    self.ObjectEdit = function () {
        var def = $.Deferred();
        if (self.SelectedNode().IsNew()) {
            tabPage.IsLoading(true);
            var currentNode = ko.map.toJS(self.SelectedNode());
            self.RemoveParentRek(currentNode);
            Bao.post("CreationWizard/EditModel", JSON.stringify({
                editItem: currentNode
            }), function (editResult) {
                self.ShowDialog(editResult, function (editVM) {
                    return self.updateName(editVM);
                });
                tabPage.IsLoading(false);
                def.resolve();
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    self.updateName = function (editModel) {
        self.SelectedNode().Text(editModel.ConfigurationItemName());
    };
    self.DeleteNode = function () {
        if (self.SelectedNode().IsNew()) {
            var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgCreationWizardRemoveObject"), "yesno");
            questionDialog.DialogResult.subscribe(function (result) {
                if (result === true) {
                    if (self.SelectedNode().Parent != null) {
                        var nodeCollection;
                        nodeCollection = self.SelectedNode().Parent.Nodes;
                        $.each(nodeCollection(), function (index, item) {
                            if (item == self.SelectedNode()) {
                                nodeCollection.remove(item);
                            }
                        });
                        self.SelectedNode(null);
                        self.ToggleButtons();
                    }
                }
            });
        }
    };
    self.SortNodes = function (nodesArray) {
        nodesArray.sort(function (itemA, itemB) {
            var textA = itemA.Text().toLowerCase();
            var textB = itemB.Text().toLowerCase();
            return textA == textB ? 0 : textA < textB ? -1 : 1;
        });
    };
    self.BeforeClose = function (fn) {
        var rootNode = ko.map.toJS(self.Nodes()[0]);
        if (self.TreeHasNewNode(rootNode, false)) {
            var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSaveCheck"), "question");
            questionDialog.DialogResult.subscribe(function (result) {
                if (result === true) {
                    tabPage.IsLoading(true);
                    self.SaveTree().done(function (data) {
                        tabPage.IsLoading(false);
                        self.DestroyObject();
                        fn();
                    });
                }
                else if (result === false) {
                    self.DestroyObject();
                    fn();
                }
            });
        }
        else {
            self.DestroyObject();
            fn();
        }
    };
    self.ShowDialog = function (dialogDataSource, fn) {
        tabPage.IsLoading(true);
        Bao.get("CreationWizard/Dialog", function (dialogView) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
            var dialogVM = new CreationWizardDialogViewModel(tabPage);
            dialog.Buttons([{
                    Title: Bao.Session.GetMessage("msgOk"),
                    Click: function () {
                        fn(dialog.ViewModel());
                        dialog.Close();
                    },
                    Enabled: dialogVM.EnableOk
                }, {
                    Title: Bao.Session.GetMessage("msgCancel"),
                    Click: function () {
                        dialog.Close();
                    },
                    Enabled: ko.observable(true)
                }]);
            dialog.Width(500);
            ko.map.fromJS(dialogDataSource, dialogVM);
            dialog.ViewModel(dialogVM);
            dialog.Template(dialogView);
            dialog.Open();
            tabPage.IsLoading(false);
        });
    };
    tabPage.MenuEvents.push(BaoMenu.registerEvent(function (value) {
        if (tabPage.IsActiveTab()) {
            switch (value.ActionKey()) {
                case "CreationWizardObjectAdd":
                    self.CreationWizardAddObject();
                    break;
                case "CreationWizardEdit":
                    self.ObjectEdit();
                    break;
                case "CreationWizardObjectDelete":
                    self.DeleteNode();
                    break;
                case "CreationWizardSave":
                    self.SaveTree();
                    break;
                case "CreationWizardRefresh":
                    self.Refresh();
                    break;
            }
        }
    }));
    self.loaded = function () {
        if (tabPage.Object != null && tabPage.Object.rootId != null) {
            self.SelectedConfigurationItemId(tabPage.Object.rootId);
            self.SelectedConfigurationItemName(tabPage.Object.rootobjectName);
        }
        if (self.RefreshInProgress() == false) {
            tabPage.IsLoading(false);
        }
        self.ToggleButtons();
    };
}
Bao.inherit(CreationWizardViewModel, BaseViewModel);
export default CreationWizardViewModel;